/* jshint undef: true, unused: true */
/* globals require */

var FoBuComponentFactory = require('./fobu-component-factory');

module.exports = function component (componentSettings, foBu) {

  var componentFactory = new FoBuComponentFactory(componentSettings, foBu),
      componentObject  = componentFactory.getComponentObject(),
      element          = componentObject.element,
      wrapper          = componentObject.wrapper;


  if (!componentSettings.autoComplete.initScript) {
    console.log('initScript not set for autoComplete input #' + element.id);
  } else {
    var autoComplete = componentSettings.autoComplete.initScript(element);

    foBu.autoCompleteInstances.push(autoComplete);
  }

  foBu.addAttributes(element, {
    'type'         : 'text',
    'autocomplete' : 'off'
  });

  foBu.manageEventListener(element, 'change', function (event) {
    foBu.validation.validateElement(foBu.settings.uid, event.target.name);
  });

  wrapper.appendChild(element);


  return {
    wrapper           : wrapper,
    finaliseComponent : componentFactory.finaliseComponent
  };
};
